import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Components Styled
import { Container, BodyContainer } from './styles';

// Components
import MainHeader from '../../display/Header';

// Hooks
import { useAuth } from '../../../hooks/useAuth';

export default function MainLayout(): JSX.Element {
  const userData = useAuth();
  if (!userData?.user?.user?.validated) {
    return <Navigate to="/login" replace />;
  }

  const userName = `${userData.user.user.name?.trim() || ''} ${
    userData.user.user.surName?.trim().split(' ')[0] || ''
  }`;

  // CAMBIO: email solo si existe (operarios sin email)
  const userMail = userData.user.user.email || undefined;

  return (
    <Container>
      <MainHeader
        variant="big"
        userName={userName}
        userMail={userMail}
        userRole={userData.user.user.rolActive}
      />
      <BodyContainer>
        <Outlet />
      </BodyContainer>
    </Container>
  );
}
